export const IconSend = () => {
    return (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4038_15354)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.6393 5.98166L13.7825 18.7859L11.6948 14.6792C11.657 14.6048 11.6169 14.5318 11.5748 14.4603L14.756 11.279C15.1466 10.8885 15.1466 10.2553 14.756 9.86479C14.3655 9.47427 13.7324 9.47427 13.3418 9.86479L10.1605 13.0461C10.089 13.004 10.0161 12.964 9.94182 12.9262L5.83511 10.8384L18.6393 5.98166ZM17.93 4.11167C19.5422 3.50016 21.1208 5.07882 20.5093 6.69097L15.6525 19.4952C15.0367 21.1187 12.7866 21.2401 11.9997 19.6922L9.91194 15.5855C9.71997 15.2079 9.41307 14.901 9.03546 14.709L4.92875 12.6213C3.3809 11.8344 3.50228 9.58425 5.1258 8.96843L17.93 4.11167Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_4038_15354">
                    <rect width="24" height="24" fill="currentColor" transform="translate(0 0.175781)" />
                </clipPath>
            </defs>
        </svg>
    );
};
